module.exports = __webpack_public_path__ + "static/img/kefuerweima.04915fb.jpg";